import axios from '../utils/axios';

export default function updateSeekerSubscription (adminId, data) {
    return axios.post(`/admin/${adminId}/update-seeker-pro`, data);
}